import { lazy, Suspense } from 'react'

import { FullScreenLoader } from '@ngb-frontend/shared/ui'

import type {
  DashboardStepValues,
  StepComponentContainer,
} from '@ngb-frontend/shared/types'

const DashboardStepLazy = lazy(() => import('./DashboardStep'))

export const DashboardStepContainer: StepComponentContainer<
  DashboardStepValues
> = (props) => {
  return (
    <Suspense fallback={<FullScreenLoader />}>
      <DashboardStepLazy {...props} />
    </Suspense>
  )
}

DashboardStepContainer.areStepPrerequisitesMet = (
  _mergedFlowData,
): _mergedFlowData is object => true
